import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import messages from './messages';
import { SegmentedChoice } from './SegmentedChoice';
import { OFFER, OPENING, SubjectType } from './types';

interface SubjectTypeToggleProps {
  value: SubjectType;
  onChange: (next: SubjectType) => void;
}

const SIDES: Array<{ value: SubjectType; label: MessageDescriptor }> = [
  { value: OFFER, label: messages.offersTab },
  { value: OPENING, label: messages.openingsTab },
];

/**
 * The segmented [ Offers | Openings ] filter over the rule table
 * (Design Requirements §2).
 *
 * A radio group wearing segments, not the `Tabs` strip this replaced — see
 * `SegmentedChoice` for why that shape. Why it is a filter and not a second tab
 * strip is `layout-composition`'s distinction: tab navigation is for "sections
 * switchable without a URL change", a segment filter for "filtering the primary
 * content view". These two sides are one entity-agnostic table filtered by
 * `subject_type`, so this is the second, and `role="tablist"` is left to the
 * page's own strip.
 */
export const SubjectTypeToggle: React.FC<SubjectTypeToggleProps> = ({
  value,
  onChange,
}) => {
  const intl = useIntl();

  return (
    <SegmentedChoice
      label={intl.formatMessage(messages.subjectTypeLabel)}
      onChange={onChange}
      options={SIDES.map(side => ({
        value: side.value,
        label: intl.formatMessage(side.label),
      }))}
      value={value}
    />
  );
};
